import { CalendarIcon, ZapIcon, TargetIcon, GamepadIcon, SmartphoneIcon, type LucideIcon } from 'lucide-react';

export interface Bonus {
  icon: LucideIcon;
  emoji: string;
  title: string;
  value: string;
  text: string;
}

export const bonuses: Bonus[] = [
  {
    icon: CalendarIcon,
    emoji: '🗓️',
    title: 'Plan de Arranque 7 Días',
    value: '9,90€',
    text: 'Una primera semana organizada: observa al equipo, define una prioridad, aplica dos sesiones y decide los siguientes ajustes. Incluye una tercera sesión opcional y las fichas completas para trabajar sin saltar de documento.'
  },
  {
    icon: ZapIcon,
    emoji: '⚡',
    title: 'Sesión Express 15 Minutos',
    value: '12,90€',
    text: '20 sesiones express de 15 minutos de práctica, con activación, tarea técnica, juego y cierre. Para un bloque breve o para integrarlas en un entrenamiento más largo.'
  },
  {
    icon: TargetIcon,
    emoji: '🎯',
    title: '30 Entrenamientos Listos para Aplicar',
    value: '14,90€',
    text: '30 sesiones completas de 75 minutos, organizadas en tres niveles. Cada entrenamiento ocupa dos páginas e incluye material, tiempos, tareas, aplicación al juego, errores frecuentes, correcciones y adaptaciones.'
  },
  {
    icon: GamepadIcon,
    emoji: '🏐',
    title: '30 Juegos Técnicos para Base',
    value: '11,90€',
    text: '30 juegos para trabajar habilidades y decisiones con reglas claras, puntuación, organización del grupo y opciones para facilitar o aumentar el reto. Elige por el nivel real de tus jugadores.'
  },
  {
    icon: SmartphoneIcon,
    emoji: '📱',
    title: 'Mapa de Temporada en una Página',
    value: '9,90€',
    text: 'Un mapa imprimible de 40 semanas, con dos propuestas de entrenamiento por semana, objetivos por bloque y criterios de seguimiento. Incluye el mapa cumplimentado, una plantilla en blanco y una guía para adaptarlo a tu calendario.'
  }
];
